// extracted by mini-css-extract-plugin
export default {"section":"Er-z","sectionTitle":"Fr-z","fieldWrapper":"Gr-z","formField":"Hr-z","disabled":"Ir-z","formLabel":"Jr-z"};